import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState } from '@typings/requestPayloads'

export interface ISearchEventsPayload {
    pagination?: any
    query?: any
    textSearch?: string
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 100
    },
    errors: null
}

const searchEventsSlice = createSlice({
    name: 'hub/events/search-events',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ISearchEventsPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const searchEventsActions = searchEventsSlice.actions
export default searchEventsSlice.reducer
